import moment from "moment";

/**
 * Builds scheduler busy-slot timestamp strings using the same
 * formatting rules as Add/Edit busy-slot flows.
 *
 * @param {object} params
 * @param {moment.Moment} params.eventDateMoment
 * @param {boolean} params.isAllDayBusy
 * @param {moment.Moment|string|Date|null} params.timeValue
 * @param {"startOf"|"endOf"} params.startOrEnd
 * @returns {string|null}
 */
export const formatBusySlotTimeValue = ({
  eventDateMoment,
  isAllDayBusy,
  timeValue,
  startOrEnd,
}) => {
  if (isAllDayBusy) {
    return moment(eventDateMoment)[startOrEnd]("day").format("YYYY-MM-DDTHH:mm");
  }
  if (!timeValue) return null;
  return (
    moment(eventDateMoment).format("YYYY-MM-DDT") + moment(timeValue).format("HH:mm")
  );
};

